import { inject, Injectable, signal } from '@angular/core';
import { BrowserContext } from '../browser-context.service';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  private readonly ctx = inject(BrowserContext);
  public readonly currentEvent = signal(this.getEvent());

  private getEvent() {
    if (this.ctx.isBrowser) {
      const params = new URLSearchParams(this.ctx.window.location.search).get('event');
      const item = this.ctx.window.localStorage.getItem('event');
      const event = params ?? item;
      if (event === null) {
        if (this.isBetweenAdventOrDec1AndJan6()) {
          return 'christmas';
        }
        if (this.isEasterSeason()) {
          return 'easter';
        }
      }
      return event;
    } else {
      return null;
    }
  }

  private isBetweenAdventOrDec1AndJan6(): boolean {
    const today = new Date();
    const currentYear = today.getFullYear();

    // December 1st
    const dec1 = new Date(currentYear, 11, 1);
    const firstAdvent = this.getFirstSundayOfAdvent(currentYear);
    const start = dec1 < firstAdvent ? dec1 : firstAdvent;

    const end = new Date(currentYear, 0, 6);

    // Handle year crossover (Dec – Jan)
    return today >= start || today <= end;
  }

  private getFirstSundayOfAdvent(year: number): Date {
    // December 25
    const christmas = new Date(year, 11, 25);
    const dayOfWeek = christmas.getDay(); // 0=Sunday
    const christmasSunday = new Date(christmas);
    christmasSunday.setDate(christmas.getDate() - dayOfWeek);
    // First Sunday of Advent = 3 Sundays before Christmas Sunday
    const firstAdvent = new Date(christmasSunday);
    firstAdvent.setDate(christmasSunday.getDate() - 21);
    return firstAdvent;
  }

  private isEasterSeason(): boolean {
    const today = new Date();
    const year = today.getFullYear();
    const easterSunday = this.getEasterSunday(year);

    // Good Friday (2 days before Easter)
    const goodFriday = new Date(easterSunday);
    goodFriday.setDate(easterSunday.getDate() - 2);

    // Easter Monday (day after Easter)
    const easterMonday = new Date(easterSunday);
    easterMonday.setDate(easterSunday.getDate() + 1);

    // Check if today is between Good Friday and Easter Monday
    return today >= goodFriday && today <= easterMonday;
  }

  // Meeus/Jones/Butcher algorithm for calculating Easter Sunday
  private getEasterSunday(year: number): Date {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31); // 3=March, 4=April
    const day = ((h + l - 7 * m + 114) % 31) + 1;

    return new Date(year, month - 1, day); // month is 0-indexed
  }
}
